module.exports = __webpack_public_path__ + "static/media/card-bg.0da8badb.png";